import React from "react"

const Link = ({ to, children }) => (
  <a className="underline text-orange-500 hover:text-orange-600" href={to}>
    {children}
  </a>
)

export default Link
